import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { jsx as _jsx } from "react/jsx-runtime";
export default function getRecipientName(contact) {
  if (!contact) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "summary.recipientsTable.row.someone"
    });
  }
  const firstName = getProperty(contact, 'firstname');
  const lastName = getProperty(contact, 'lastname');
  const email = getProperty(contact, 'email') || '';
  if (!firstName && !lastName && !email) return null;
  return /*#__PURE__*/_jsx(FormattedName, {
    givenName: firstName,
    familyName: lastName,
    email: email
  });
}
export const getRecipientNameCHIRP = contact => {
  if (!contact) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "summary.recipientsTable.row.someone"
    });
  }
  const {
    firstName,
    lastName,
    email
  } = contact;
  return /*#__PURE__*/_jsx(FormattedName, {
    givenName: firstName,
    familyName: lastName,
    email: email
  });
};